import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { User } from './interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  _baseURL: string = environment.baseURL;
  _layout: string = environment.layout;
  _content: string = environment.content;
  _site: string = environment.site
  _page: string = "monitoring_login";

  private currentUserSource = new ReplaySubject<any>(1);
  currentUser$ = this.currentUserSource.asObservable();

  constructor(private _http: HttpClient) { }

  login(user: string, pass: string, clientToken: string) {
        
    // some of this parameters could go into the interceptor
    let params = new HttpParams();
        params = params.append("site", this._site);
        params = params.append("layout", this._layout);
        params = params.append("page", this._page);
        params = params.append("content", this._content);
        params = params.append("username", user);
        params = params.append("password", pass);
        params = params.append("clientToken", clientToken);
        params = params.append("action", "login");

    
    return this._http.get(`${this._baseURL}monitoring_login.p`, {params: params} ).pipe( map( (response:any) => { 
      
      const user: User = response.response.security[0];
      if (!user.hasError)
        this.setCurrentUser(user);
        
      return user;
    }));

  }

  setCurrentUser(user: User) {
    localStorage.setItem('user', JSON.stringify(user));
    this.currentUserSource.next(user);
  }

  logout() {
    // some of this parameters could go into the interceptor
    let params = new HttpParams();
        params = params.append("site", this._site);
        params = params.append("layout", this._layout);
        params = params.append("page", this._page);
        params = params.append("content", this._content);
        params = params.append("action", "logout");
    
    
    return this._http.get(`${this._baseURL}monitoring_login.p`, {params: params} ).pipe( map( (response:any) => { 

      const user: User = response.response.security[0];

      if (!user.hasError) {
         localStorage.removeItem('user');
         this.currentUserSource.next(null);
      }
       
      return response;

    }));    
  }

  
}
